import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/teams.js';
import q from '../query.js';
export const teamsEntity = `teams`;
const teamsKey = `teams`;
export const useTeams = (enabled) => q.query(teamsKey, api.getAll, keys.read.collection(teamsEntity), {
    enabled,
});
//# sourceMappingURL=index.js.map